import React from "react";
import { Skeleton, Group, Stack, Container } from "@mantine/core";
import "./OrganizerSettings.scss";

const OrganizerSettingsSkeleton: React.FC = () => {
  return (
    <Container className="organizer-settings">
      <Stack p="md">
        {/* Header */}
        <Group p="apart" align="flex-start">
          <Stack p="xs">
            <Skeleton height={30} width={200} />
            <Skeleton height={20} width={300} />
          </Stack>
          <Skeleton height={36} width={100} />
        </Group>

        {/* Form Type */}
        <Stack p="sm">
          <Skeleton height={24} width={150} />
          <Skeleton height={20} width="100%" />
          <Group grow>
            <Skeleton height={100} />
            <Skeleton height={100} />
          </Group>
        </Stack>

        {/* Additional Questions Section */}
        <Stack p="sm">
          <Skeleton height={24} width={250} />
          <Skeleton height={20} width="100%" />

          {/* Title and Description */}
          <Stack p="xs">
            <Skeleton height={24} width={200} />
            <Skeleton height={20} width="100%" />
            <Skeleton height={36} />
            <Skeleton height={100} />
          </Stack>

          {/* Questions */}
          <Stack p="md">
            <Group p="apart">
              <Skeleton height={24} width={150} />
              <Skeleton height={36} width={150} />
            </Group>
            {[...Array(3)].map((item, index) => (
              <Stack key={`${item}-${index}`} p="xs">
                <Skeleton height={36} />
                <Skeleton height={24} />
                <Skeleton height={36} />
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default OrganizerSettingsSkeleton;
